export default "__VITE_ASSET__d1929c3c__"